import {Component, Input} from '@angular/core';
import {
  AdditionalPropertyModel,
  AdditionalPropertyValueTypeDate,
  AdditionalPropertyValueTypeLovValueSummary,
  AdditionalPropertyValueTypeString
} from '../../model/additionalProperty.model';
import {LovValueSummary} from '../../../lov/lov-value/api/model/lovValueSummary.model';

@Component({
  selector: 'app-additional-property-label',
  templateUrl: './additional-property-label.component.html'
})
export class AdditionalPropertyLabelComponent {

  @Input() additionalProperty: AdditionalPropertyModel;
  @Input() showUndefined = false;
  @Input() showLabel = true;
  @Input() iconName: string;


  get value(): string {
    if (! this.additionalProperty) {
      return undefined;
    }

    const additionalPropertyValue = this.additionalProperty.value;
    if (!additionalPropertyValue) {
      return '/';
    }

    let value: string;
    const valueType = this.additionalProperty.valueType;
    switch (valueType) {
      case AdditionalPropertyValueTypeString:
          value = this.additionalProperty.value;
          break;
      case AdditionalPropertyValueTypeLovValueSummary:
          value = (this.additionalProperty.value as LovValueSummary).label;
          break;
      case AdditionalPropertyValueTypeDate:
        const date: Date = new Date(this.additionalProperty.value);
          value = date.toLocaleDateString();
          break;
      default:
        value = '???';
    }
    return value;
  }

  get shouldDisplay(): boolean {
    return !this.showUndefined ? !!this.additionalProperty?.value : !!this.additionalProperty;
  }

  get label(): string {
    return this.showLabel ? this.additionalProperty.label : undefined;
  }

}
